import React, { useEffect, useState } from "react";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { useKardex } from "../../../hooks/reportes/useKardex";
import { AutoComplete } from "../../components/forms/AutoComplete";
import { useBloqueoPantalla } from "../../../hooks/useBloqueoPantalla";
import { useMovimientos } from "../../../hooks/almacen/useMovimientos";

export const Kardex = () => {
    const [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo] = useBloqueoPantalla()

    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   
    const [almacenSeleccionado,setAlmacenSeleccionado] = useState(0)
    const [productoSeleccionado,setProductoSeleccionado] = useState(0)
    const [valoresProcesar,setValoresProcesar] = useState({
        codAlmacen: 0,
        codProducto: 0
    })

    const {
        listarKardex,
        elementosKardex,
        listarAlmacenesParaCombo,
        almacenesCombo,
        autocompleteProductos,
        productos
    } = useKardex()

    const {
        listarAlmacenes,
        almacenes,
    } = useMovimientos()

    useEffect(() => {
        (async () => {
            bloquearPantalla()
            // await listarAlmacenesParaCombo()
            await listarAlmacenes()
            await listarKardex()
            desbloquearPantalla()
        })()
    },[])

    const funcionListarTabla = async () => {
        setValoresProcesar({
            codAlmacen: almacenSeleccionado,
            codProducto: productoSeleccionado
        })
        await listarKardex(productoSeleccionado,almacenSeleccionado)
    }

    const funcionAutocomplete = async (texto) => {
        await autocompleteProductos(texto,almacenSeleccionado)
    }

    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>
            <ContenedorParametros
                titulo='Kardex' tablaId="tablaId"
            >
                <div className="flex gap-4 items-center">
                    <div className="flex gap-2 items-center">
                        <i title="Almacenes" className="fa fa-archive" aria-hidden="true"></i>
                        <select value={almacenSeleccionado} onChange={e => setAlmacenSeleccionado(e.target.value)} className={classNameInput}>
                            <option value={0}>--Todos--</option>
                            {
                                almacenes.map((data,i) => <option key={i+1} value={data.codAlmacen}>{data.nomAlmacen}</option>)
                            }
                        </select>
                    </div>
                    <div className="flex gap-2 items-center">
                        <i title="Productos" className="fa fa-tag" aria-hidden="true"></i>
                        <AutoComplete 
                            cambiarOpcionSeleccionada={(valor) => setProductoSeleccionado(valor)}
                            funcionListaElementos={funcionAutocomplete} 
                            elementos={productos}
                        ></AutoComplete>
                    </div>
                    <BotonProcesar onClick={funcionListarTabla}></BotonProcesar>
                </div>
            </ContenedorParametros>

            <div className="containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                <table id="tablaId" className="tableResponsive">
                    <thead>
                        <tr>
                            {
                                valoresProcesar.codProducto == 0 ? 
                                    (<>
                                        <th>Nº</th>
                                        <th>PRODUCTO</th>
                                        <th className="text-right">ENTRADA</th>
                                        <th className="text-right">SALIDA</th>
                                        <th className="text-right">SALDO</th>
                                        {
                                            valoresProcesar.codAlmacen == 0 ? <th>N.ALMACEN</th> : ''
                                        }
                                    </>)
                                :
                                    (<>
                                        <th>Nº</th>
                                        <th>F.MOVIMIENTO</th>
                                        <th>MOTIVO</th>
                                        <th>DOCUMENTO</th>
                                        <th className="text-right">ENTRADA</th>
                                        <th className="text-right">SALIDA</th>
                                        <th className="text-right">SALDO</th>
                                        {
                                            valoresProcesar.codAlmacen == 0 ? <th>N.ALMACEN</th> : ''
                                        }
                                    </>)
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            elementosKardex.length != 0 ?
                                elementosKardex.map((data,i) => {
                                    return(
                                        <React.Fragment key={i+1}>
                                            {
                                                valoresProcesar.codProducto == 0 ? 
                                                    <tr>
                                                        <td className="">{i+1}</td>
                                                        <td className="">{data.nomRepuesto || '-'}</td>
                                                        <td className="text-right">{data.entrada || '0'}</td>
                                                        <td className="text-right">{data.salida || '0'}</td>
                                                        <td className="text-right">{data.saldo || '0'}</td>
                                                        {
                                                            valoresProcesar.codAlmacen == 0 ? <td className="">{data.nomAlmacen}</td> : ''
                                                        }
                                                    </tr>
                                                :
                                                    <tr>
                                                        <td className="">{i+1}</td>
                                                        <td className="">{data.fechaAlmacenMovimiento || '-'}</td>
                                                        <td className="">{data.nomMotivo || '-'}</td>
                                                        <td className="">{data.documento || '-'}</td>
                                                        <td className="text-right">{data.entrada || '0'}</td>
                                                        <td className="text-right">{data.salida || '0'}</td>
                                                        <td className="text-right">{data.saldo || '0'}</td>
                                                        {
                                                            valoresProcesar.codAlmacen == 0 ? <td className="">{data.nomAlmacen}</td> : ''
                                                        }
                                                    </tr>
                                            }
                                        </React.Fragment>
                                    )
                                })
                            :
                                <tr><td colSpan={valoresProcesar.codProducto==0 ? (valoresProcesar.codAlmacen==0 ? 6 : 5) : (valoresProcesar.codAlmacen==0 ? 8 : 7)} className="text-center">No hay información con los parametros seleccionados...</td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
};
